/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data-block__item[_ngcontent-%COMP%]{flex-basis:100%}@media screen and (min-width:760px){.data-block__item[_ngcontent-%COMP%]{flex-basis:50%}}.data-item__content-wrapper[_ngcontent-%COMP%]{display:flex;margin:auto}"];
export { styles as styles };
